/* eslint-disable react/jsx-props-no-spreading */
import { ColorField } from '@molecules';

import { Checkbox } from '@atoms';

import MediaField from '@organisms/MediaField';

import { NO_MARGIN_BOTTOM } from '@constants';
import React from 'react';

const BackgroundSelect = ({ isImgBackground, background, backgroundColours, mobileBackground }) => {
  const [backgroundImg, setBackgroundImg] = React.useState(isImgBackground);
  const handleBackgroundChange = () => {
    setBackgroundImg(!backgroundImg);
  };

  return (
    <>
      {backgroundImg ? <MediaField {...background} style={NO_MARGIN_BOTTOM} /> : <ColorField {...backgroundColours} />}
      {backgroundImg && !!mobileBackground && <MediaField {...mobileBackground} style={NO_MARGIN_BOTTOM} />}

      <Checkbox checked={backgroundImg} onChange={handleBackgroundChange}>
        Use image background
      </Checkbox>
    </>
  );
};

export default BackgroundSelect;
